import { render, staticRenderFns } from "./Schlafen1OG.vue?vue&type=template&id=753654c5"
import script from "./Schlafen1OG.vue?vue&type=script&lang=js"
export * from "./Schlafen1OG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports